export default "__VITE_ASSET__BmUwrf8J__"